import Dashelement from "components/Dashboard/Dashelement";
import AuthContext from "context/AuthContext";
import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import useCan from "hooks/useCan";
import { ROLES } from "utils/constants";

const IncompleteProfile = () => {
  let { user } = useContext(AuthContext);
  const { isStoreUser } = useCan();

  const navigate = useNavigate();
  if (user?.role === ROLES.HOST.role) {
    return (
      <div>
        <Dashelement className="features add-product-initial">
          <div className="text-wrapper-productadder">
            <h3 className="text-center">Completed your profile?</h3>
            <p className="text-center">
              We require you to complete your profile before you continue with
              other features. <br />
              Completing your profile helps you get demo request and increase a
              chance of acceptance.{" "}
            </p>
            <div className="button-wraper-productadder text-center">
              <Button onClick={() => navigate("/user/completeprofile")}>
                Complete profile
              </Button>
            </div>
          </div>
        </Dashelement>
      </div>
    );
  } else if (isStoreUser) {
    return (
      <div>
        <Dashelement className="features add-product-initial">
          <div className="text-wrapper-productadder">
            <h3 className="text-center">Completed your profile?</h3>
            <p className="text-center">
              We require you to complete your profile before you continue with
              other features. <br />
              Completing your profile is required to setup discount and
              commission and let Purebrand know about you and your store.{" "}
            </p>
            <div className="button-wraper-productadder text-center">
              <Button onClick={() => navigate("/user/completeprofile")}>
                Complete profile
              </Button>
            </div>
          </div>
        </Dashelement>
      </div>
    );
  } else if (user?.role === ROLES.PUREBRAND_ADMIN.role) {
    return (
      <div>
        <Dashelement className="features add-product-initial">
          <div className="text-wrapper-productadder">
            <h3 className="text-center">Completed your profile?</h3>
            <p className="text-center">
              We require you to complete your profile before you continue with
              other features. <br />
              Completing your profile is required to setup discount and
              commission and let Purebrand know about you and your store.{" "}
            </p>
            <div className="button-wraper-productadder text-center">
              <Button onClick={() => navigate("/user/completeprofile")}>
                Complete profile
              </Button>
            </div>
          </div>
        </Dashelement>
      </div>
    );
  }
};

export default IncompleteProfile;
